import { FormModel, FormModelPath } from "@com.mgmtp.a12.formengine/formengine-core/lib/models";
import { DefaultFormModelMap, Enablements, FormModelMap } from "@com.mgmtp.a12.formengine/formengine-core/lib/view";
import { UiStateSelectors } from "@com.mgmtp.a12.formengine/formengine-core/lib/back-end/store";

import {
	BESCHEID_ERSTELLER_MARKER,
	EMAIL_EMPFAENGER_REPEAT,
	EMAIL_EMPFAENGER_REPEAT_TYP,
	EMAIL_KONTAKLISTE_APPIDS,
	NACHFORDERUNG_MARKER,
	TEXTBAUSTEINE_KATEGORIE
} from "../../../utilities/variables/modulfRuntimeAnnotations";
import { extractConfigList } from "../../../utilities/platzhalterHelper";

import { BescheidErstellenButtons } from "./buttonsOfBescheidErstellen";
import { NachforderungRepeatButtons } from "./buttonsOfNachforderung";
import { ContactDataButton } from "./contactDataButton";

export function CustomInlineRepeat(activityId: string, isReadonly?: boolean) {
	const CustomInlineRepeat = (props: FormModelMap.FormModelComponentProps<FormModel.InlineRepeat>) => {
		const marker = props.modelElement.annotations?.find(({ name }) => name === NACHFORDERUNG_MARKER)?.value;
		const kategorie = props.modelElement.annotations?.find(({ name }) => name === TEXTBAUSTEINE_KATEGORIE)?.value;

		const isElementReadonly = Enablements.isReadonly({
			formModelPath: FormModelPath.extend(props.config.parentPath, props.modelElement),
			state: props.config.renderOptions.state,
			dataContext: UiStateSelectors.currentScreenLocation()(props.config.renderOptions.state).path
		});

		if (!isReadonly && !isElementReadonly && marker) {
			return (
				<>
					<DefaultFormModelMap.InlineRepeat.component {...props} />
					<NachforderungRepeatButtons
						inlineProps={props}
						activityId={activityId}
						marker={marker}
						disabled={isReadonly}
						kategorie={kategorie}
					/>
				</>
			);
		}

		const bescheid_erstellen_marker = props.modelElement.annotations?.find(
			({ name }) => name === BESCHEID_ERSTELLER_MARKER
		)?.value;
		if (!isReadonly && bescheid_erstellen_marker) {
			return (
				<>
					<DefaultFormModelMap.InlineRepeat.component {...props} />
					<BescheidErstellenButtons
						activityId={activityId}
						inlineProps={props}
						disabled={isReadonly}
						fvKey={bescheid_erstellen_marker}
						kategorie={kategorie}
					/>
				</>
			);
		}

		if (
			props.modelElement.annotations?.find(({ name }) => name === EMAIL_EMPFAENGER_REPEAT)?.value ===
				EMAIL_EMPFAENGER_REPEAT_TYP &&
			!isReadonly
		) {
			const appIds = props.modelElement.annotations?.find(({ name }) => name === EMAIL_KONTAKLISTE_APPIDS)?.value;
			const appList = appIds ? extractConfigList(appIds) : [];

			return (
				<>
					{appList.length > 0 && (
						<ContactDataButton activityId={activityId} inlineProps={props} appKeys={appList} />
					)}
					<DefaultFormModelMap.InlineRepeat.component {...props} />
				</>
			);
		}

		return <DefaultFormModelMap.InlineRepeat.component {...props} />;
	};
	return CustomInlineRepeat;
}
